import React, { useMemo } from 'react';

import useWebStorage from '@/hooks/useWebStorage';

import { SearchResult, SearchResultType } from './models';
import { PreviousSearchResultsStorageKey } from './onMapSearch';
import { SearchElement } from './searchElements';
import { SearchResultsSection } from './searchResultsSection';

type Props = {
  onResultsClickMap: Record<
    SearchResultType,
    (result: SearchResult<any>) => void
  >;
};

export const SearchPreviousResults: React.FC<Props> = ({
  onResultsClickMap,
}) => {
  const { savedValue } = useWebStorage<SearchResult<any>[]>({
    key: PreviousSearchResultsStorageKey,
  });

  const previousResults: SearchResult<any>[] = useMemo(() => {
    if (!savedValue || typeof savedValue !== 'object') {
      return [];
    }

    return savedValue;
  }, [savedValue]);

  if (!previousResults?.length) {
    return null;
  }

  return (
    <div className="pointer-events-auto flex shrink flex-col overflow-auto rounded-md bg-gray-10 py-1">
      <SearchResultsSection title="Recently Searched">
        {previousResults.map((previousResult, index) => (
          <SearchElement
            key={previousResult.id}
            focus={false}
            index={index}
            value={previousResult.label}
            onArrowClick={
              [SearchResultType.STATE, SearchResultType.COUNTY].includes(
                previousResult.type
              )
                ? () => {
                    onResultsClickMap[previousResult.type](previousResult);
                  }
                : undefined
            }
            onClick={() => {
              onResultsClickMap[previousResult.type](previousResult);
            }}
            onMouseEnter={() => {}}
          />
        ))}
      </SearchResultsSection>
    </div>
  );
};
